export default function HashChangeListenerMixin(sections, allSections, behavior = 'smooth') {
  return {
    data: () => ({
      sections,
      allSections,
      activeSectionIndex: 0,
      activeSection: null,
    }),
    methods: {
      handleSectionClick(section) {
        if (typeof section === 'string') history.replaceState(null, null, '#' + section);
        else history.replaceState(null, null, '#' + section.title.toLowerCase().replace(/ /g, '-'));
      },
      sectionToHash: (section) => section.title.toLowerCase().replace(/ /g, '-'),
      async handleHashChange() {
        if (!location.hash) return;
        this.activeSection = this.allSections.find(
          (section) => this.sectionToHash(section) === location.hash.substring(1),
        );
        this.activeSectionIndex = this.allSections.indexOf(this.activeSection);
        await this.$nextTick();
        document.getElementById(this.sectionToHash(this.activeSection)).scrollIntoView({ behavior });
      },
    },
    async mounted() {
      await this.$nextTick();
      await this.handleHashChange();
      window.addEventListener('history-replace-state', this.handleHashChange);
    },
    beforeDestroy() {
      window.removeEventListener('history-replace-state', this.handleHashChange);
    },
  };
}
